const $inject = [];

const zeroPaddingFilter = () => {
  return (input, char, n) => {
    if(input === undefined) {
      input = '';
    }

    return _.padStart(input, n, char);
  };
};

zeroPaddingFilter.$inject = $inject;

export default zeroPaddingFilter;



// WEBPACK FOOTER //
// ./src/filters/paddingFilter.js